export const campaign = {
  Id: "id",
  Naam: "name",
  "Naam van de bron": "resource_name",
  "Toestand": "status",
  "Type advertentiekanaal": "advertising_channel_type",
  "Type biedstrategie": "bidding_strategy_type",
  "Campagne Budget": "campaign_budget",
}

const metricsLowercased = {
  "Alle conversies": "all_conversions",
  "Gemiddelde kosten": "average_cost",
  "Gemiddelde cpc": "average_cpc",
  "Gemiddelde tijd ter plaatse": "average_time_on_site",
  "Bouncepercentage": "bounce_rate",
  "Kosten micro's": "cost_micros",
  "Kosten per conversie": "cost_per_conversion",
  "Ctr": "ctr",
  "Betrokkenheidspercentage": "engagement_rate",
  "Betrokkenheid": "engagements",
  "Impressies": "impressions",
  "Absoluut top vertoningspercentage": "absolute_top_impression_percentage",
  "Zichtbaarheid van actieve weergave": "active_view_viewability",
  "Meetbare vertoningen van actieve weergave": "active_view_measurable_impressions",
  "Actieve weergave meetbare kostenmicro's": "active_view_measurable_cost_micros",
  "Cpm actieve weergave": "active_view_cpm",
  "Actieve weergave ctr": "active_view_ctr",
  "Vertoningen van actieve weergave": "active_view_impressions",
  "Meetbaarheid van actieve weergave": "active_view_measurability",
  "alle conversies": "all_conversions",
  "alle conversies waarde per kosten": "all_conversions_value_per_cost",
  "alle conversies waarde op conversiedatum": "all_conversions_value_by_conversion_date",
  "alle conversies van interacties waarde per interactie": "all_conversions_from_interactions_value_per_interaction",
  "alle conversies waarde": "all_conversions_value",
  "alle conversies op basis van interacties": "all_conversions_from_interactions_rate",
  "alle conversies op conversiedatum": "all_conversions_by_conversion_date",
  "gemiddelde tijd ter plaatse": "average_time_on_site",
  "gemiddelde paginaweergaven": "average_page_views",
  "gemiddelde cpv": "average_cpv",
  "gemiddelde cpm": "average_cpm",
  "gemiddelde cpe": "average_cpe",
  "gemiddelde cpc": "average_cpc",
  "gemiddelde kosten": "average_cost",
  "bouncepercentage": "bounce_rate",
  "klikken": "clicks",
  "conversies": "conversions",
  "ctr": "ctr",
  "conversies tussen verschillende apparaten": "cross_device_conversions",
  "kosten per huidig ​​model toegeschreven conversie": "cost_per_current_model_attributed_conversion",
  "kosten per conversie": "cost_per_conversion",
  "kosten per alle conversies": "cost_per_all_conversions",
  "kosten micro's": "cost_micros",
  "conversies op conversiedatum": "conversions_by_conversion_date",
  "conversies van interactiepercentage": "conversions_from_interactions_rate",
  "conversiewaarde": "conversions_value",
  "conversiewaarde op conversiedatum": "conversions_value_by_conversion_date",
  "conversiewaarde per kosten": "conversions_value_per_cost",
  "huidige model toegeschreven conversies": "current_model_attributed_conversions",
  "huidige model toegeschreven conversiewaarde": "current_model_attributed_conversions_value",
  "betrokkenheidspercentage": "engagement_rate",
  "verlovingen": "engagements",
  "gmail doorsturen": "gmail_forwards",
  "gmail slaat op": "gmail_saves",
  "gmail secundaire klikken": "gmail_secondary_clicks",
  "historische creatieve kwaliteitsscore": "historical_creative_quality_score",
  "historische kwaliteitsscore van bestemmingspagina's": "historical_landing_page_quality_score",
  "historische kwaliteitsscore": "historical_quality_score",
  "historisch zoeken voorspelde ctr": "historical_search_predicted_ctr",
  "typen interactiegebeurtenissen": "interaction_event_types",
  "interacties": "interactions",
  "interactiepercentage": "interaction_rate",
  "impressies": "impressions",
  "procent nieuwe bezoekers": "percent_new_visitors",
  "zoek absolute top vertoningspercentage": "search_absolute_top_impression_share",
  "zoekbudget verloren absoluut hoogste vertoningspercentage": "search_budget_lost_absolute_top_impression_share",
  "zoekbudget verloren hoogste vertoningspercentage": "search_budget_lost_top_impression_share",
  "zoeken klik delen": "search_click_share",
  "vertoningspercentage voor exact zoeken voor zoeken": "search_exact_match_impression_share",
  "vertoningspercentage zoeken": "search_impression_share",
  "zoekpositie verloren absolute top vertoningspercentage": "search_rank_lost_absolute_top_impression_share",
  "zoekpositie verloren vertoningspercentage": "search_rank_lost_impression_share",
  "zoekpositie verloren hoogste vertoningspercentage": "search_rank_lost_top_impression_share",
  "top vertoningspercentage zoeken": "search_top_impression_share",
  "hoogste vertoningspercentage": "top_impression_percentage",
  "waarde per alle conversies": "value_per_all_conversions",
  "waarde per alle conversies op conversiedatum": "value_per_all_conversions_by_conversion_date",
  "waarde per conversie": "value_per_conversion",
  "waarde per conversies op conversiedatum": "value_per_conversions_by_conversion_date",
  "waarde per huidig ​​model toegeschreven conversie": "value_per_current_model_attributed_conversion",
  "video kwartiel p100 tarief": "video_quartile_p100_rate",
  "video kwartiel p25 tarief": "video_quartile_p25_rate",
  "video kwartiel p50 tarief": "video_quartile_p50_rate",
  "video kwartiel p75 tarief": "video_quartile_p75_rate",
  "videoweergavesnelheid": "video_view_rate",
  "videoweergaven": "video_views",
  "bekijken via conversies": "view_through_conversions",
}

const uppercased = {}
Object.keys(metricsLowercased).forEach(key => {
  uppercased[key[0].toUpperCase() + key.substring(1)] = metricsLowercased[key]
})

export const metrics = uppercased

const shouldNotHaveDefault = ["name", "resource_name", "campaign_budget"]
export const defaultSizes = Object.keys({...metrics, ...campaign}).reduce((obj, key) => {
  if (shouldNotHaveDefault.includes(key)) return obj
  return {...obj, [key]: 150}
}, {})

